import type { LucideIcon } from 'lucide-react';
import { TbChalkboardTeacher } from 'react-icons/tb';
import {
  LayoutGrid,
  GraduationCap,
  MessageCircleMore,
  Users,
  BookOpen,
  Settings,
  Gift,
  Copy,
  Video,
  CalendarCheck,
  Megaphone,
  BookMarked,
  FileText,
} from 'lucide-react';
import type { Action, Subject } from '@new/casl';

export interface SidebarConfigItem {
  key: string;
  label: string;
  to: string;
  icon: LucideIcon;
  action: Action;
  subject: Subject;
  children?: SidebarConfigItem[];
}

export const SIDEBAR_ITEMS: SidebarConfigItem[] = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    to: '/',
    icon: LayoutGrid,
    action: 'access',
    subject: 'Dashboard',
  },
  {
    key: 'degrees',
    label: 'Degrees',
    to: '/degrees',
    icon: GraduationCap,
    action: 'access',
    subject: 'Degree',
  },
  {
    key: 'courses',
    label: 'Courses',
    to: '/courses',
    icon: BookMarked,
    action: 'read',
    subject: 'Course',
  },
  {
    key: 'transcripts-review',
    label: 'Transcripts',
    to: '/transcripts-review',
    icon: FileText,
    action: 'access',
    subject: 'TranscriptsReview',
  },
  {
    key: 'projects',
    label: 'Projects',
    to: '/projects',
    icon: BookOpen,
    action: 'access',
    subject: 'ProjectsReview',
  },
  {
    key: 'course-hearings',
    label: 'Course Hearings',
    to: '/course-hearings',
    icon: TbChalkboardTeacher as any,
    action: 'access',
    subject: 'CourseHearing',
  },
  {
    key: 'inbox',
    label: 'Inbox',
    to: '/chat',
    icon: MessageCircleMore,
    action: 'access',
    subject: 'Chat',
  },
  {
    key: 'students',
    label: 'Students',
    to: '/students',
    icon: Users,
    action: 'read',
    subject: 'Student',
  },

  {
    key: 'schedule',
    label: 'Schedule',
    to: '/schedule',
    icon: CalendarCheck,
    action: 'access',
    subject: 'Schedule',
  },
  {
    key: 'feedback',
    label: 'Media Feedback',
    to: '/objective-media-review',
    icon: BookOpen,
    action: 'read',
    subject: 'Feedback',
  },
  {
    key: 'announcements',
    label: 'Announcements',
    to: '/announcements',
    icon: Megaphone,
    action: 'access',
    subject: 'Announcement',
  },
  {
    key: 'administration',
    label: 'Administration',
    to: '#',
    icon: Settings,
    action: 'access',
    subject: 'AdminPanel',
    children: [
      {
        key: 'admin-users',
        label: 'Users',
        to: '/admin/users',
        icon: Users,
        action: 'manage',
        subject: 'User',
      },
      {
        key: 'admin-coupons',
        label: 'Coupons',
        to: '/admin/coupons',
        icon: Gift,
        action: 'manage',
        subject: 'Billing',
      },
      {
        key: 'admin-agreements',
        label: 'Agreements',
        to: '/admin/agreements',
        icon: Copy,
        action: 'manage',
        subject: 'Account',
      },
      {
        key: 'admin-recordings',
        label: 'Video Call Recordings',
        to: '/admin/video-call-recordings',
        icon: Video,
        action: 'manage',
        subject: 'Analytics',
      },
    ],
  },
];
